import React from 'react';
import DbDashboard from '../views/DbDashboard';

function DbHealthHome(props){
    return <div><DbDashboard/></div>;
}

export default DbHealthHome;
